import { useEffect, useRef } from "react";

const SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY;

// Renders a Cloudflare Turnstile widget (explicit render) and hands the token to onVerify.
// No-ops (renders nothing) when the site key is not configured, so dev without keys still works.
export default function TurnstileWidget({ onVerify, onExpire, action, className, theme = "light" }) {
  const ref = useRef(null);
  const idRef = useRef(null);

  useEffect(() => {
    if (!SITE_KEY) return undefined;
    let cancelled = false;

    const tryRender = () => {
      if (cancelled || idRef.current !== null) return true;
      if (!window.turnstile || !ref.current) return false;
      idRef.current = window.turnstile.render(ref.current, {
        sitekey: SITE_KEY,
        action,
        theme,
        callback: (token) => { if (!cancelled) onVerify?.(token); },
        "expired-callback": () => { if (!cancelled) onExpire?.(); },
        "error-callback": () => { if (!cancelled) onExpire?.(); },
      });
      return true;
    };

    let iv = null;
    if (!tryRender()) iv = setInterval(() => { if (tryRender() && iv) { clearInterval(iv); iv = null; } }, 200);

    return () => {
      cancelled = true;
      if (iv) clearInterval(iv);
      if (idRef.current !== null && window.turnstile) {
        try { window.turnstile.remove(idRef.current); } catch (e) { /* ignore */ }
        idRef.current = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!SITE_KEY) return null;
  return <div ref={ref} className={className} data-testid="turnstile-widget" />;
}
